import {BankAccountResponseBody} from '@dms/api/shared';

import {getDefaultDomainBankAccount, getDomainBankAccounts} from './getDomainBankAccounts';

/**
 * Returns bank accounts valid for the SALES domain.
 *
 * When the domain system is active (at least one account carries a domain tag),
 * only SALES-tagged accounts and untagged accounts are returned.
 */
export function getSalesBankAccounts(accounts: BankAccountResponseBody[]) {
  return getDomainBankAccounts(accounts, 'SALES');
}

/**
 * Returns default bank account for the SALES domain.
 *
 * Priority:
 * 1. Currency-matching SALES account (if currency provided)
 * 2. Primary SALES account
 * 3. First SALES account
 *
 * Falls back through the same priority for untagged accounts when no domain system is active.
 */
export function getDefaultSalesBankAccount(accounts: BankAccountResponseBody[], currency?: string) {
  return getDefaultDomainBankAccount(accounts, 'SALES', currency);
}
